import { DirtScoreEnum } from 'api';
import { translate } from 'i18n';

export const formatDirtScore = (dirtScore: DirtScoreEnum | undefined | null) => {
  if (!dirtScore) {
    return translate('backlog.breakdowns.formatDirtScore.notAvailable', { namespace: 'features' });
  }
  switch (dirtScore) {
    case DirtScoreEnum.VERY_CLEAN:
      return translate('backlog.breakdowns.formatDirtScore.veryClean', { namespace: 'features' });
    case DirtScoreEnum.CLEAN:
      return translate('backlog.breakdowns.formatDirtScore.clean', { namespace: 'features' });
    case DirtScoreEnum.AVERAGE:
      return translate('backlog.breakdowns.formatDirtScore.average', { namespace: 'features' });
    case DirtScoreEnum.DIRTY:
      return translate('backlog.breakdowns.formatDirtScore.dirty', { namespace: 'features' });
    default:
      return translate('backlog.breakdowns.formatDirtScore.notAvailable', { namespace: 'features' });
  }
};
